import { useQuery } from 'react-query'
import { listSuccessFiles } from '../api'
import dayjs from 'dayjs'
import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from '../constant/query'

const useSuccessFiles = () => {
  const { isError, refetch, isFetching, isLoading, error, isSuccess, data } =
    useQuery('SUCCESS_FILES', listSuccessFiles, {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      select: (data) =>
        data.sort((a, b) => dayjs(b.createdAt).diff(a.createdAt)),
      staleTime: QUERY_STALE_TIME, // 5 minutes
      cacheTime: QUERY_CACHE_TIME, // 10 minutes
    })

  return {
    files: data || [],
    isError,
    refetch,
    isFetching,
    isLoading,
    error,
    isSuccess,
  }
}

export default useSuccessFiles
